// custom code
$(function () {
    // Preview might have multiple events on the same page, so we should do each one individually
    const $events = $('.event-content-wrap');
    if ($events.length) {
        const processEvent = function ($content) {
            // adjust images
            $content.find('.event-description img').each(function () {
                var $img = $(this);
                if ($img.parent().text().trim()) {
                    $img.addClass('float-image');
                }
            });

            // use momentjs to format datetime
            var $date = $content.find('.event-date'),
                $time = $content.find('.event-time');
            var so = $date.data('startson'),
                eo = $date.data('endson');
            if (so && eo) {
                var startsOn = moment($date.data('startson')),
                    endsOn = moment($date.data('endson'));
                var dateFormat = 'dddd, MMMM D, Y',
                    timeFormat = 'h:mm A';
                $date.text(startsOn.format(dateFormat) + (startsOn.isSame(endsOn, 'day') ? '' : (' - ' + endsOn.format(dateFormat))));
                $time.text(startsOn.format(timeFormat) + ' - ' + endsOn.format(timeFormat));
            }

            // patch subdomain images
            var subHost = $content.find('.event-sponsors a[href^="http"]').attr('href');
            if (subHost) {
                if (subHost.substring(subHost.length - 1) === '/') {
                    subHost = subHost.substring(0, subHost.length - 1);
                }
                // prepend subHost to img src if they are from the media library
                $content.find('img[src^="/media/"]').each(function(){
                    var $t = $(this);
                    $t.attr('src', subHost + $t.attr('src'));
                });
            }

        };

        $events.each(function () {
            processEvent($(this));
        });
    }
});

$(function(){

    $('a[href^="mailto:"]').each(function(){
        var $this = $(this);
        var email = $this.text().trim();
        if (email === 'institutionaladvancement@tc.columbia.edu') {
            $this.html('institutionaladvancement<br class="ia-email-break"/>@tc.columbia.edu');
        }
    });
    
    });